module.exports = __webpack_public_path__ + "./docs/img/icon-alert.c1029c070969a160919f3d8280898872.svg";